/* eslint-disable max-len */
// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

export const MESSAGE_RESTORE_SUCCESS_ONE = 'Data encryption key has been successfully restored, your Marketing Cloud account will be offline while it is being restored. ';
export const MESSAGE_RESTORE_SUCCESS_TWO = 'Marketing Cloud requires up to one week to verify and restore your database, especially if a major Marketing Cloud release occurred between the revoke and restore requests.';
export const MESSAGE_RESTORE_FAILURE = 'Unable to restore encryption key at this time, try again later or contact support. RequestId: {requestId}';
export const MESSAGE_RESTORE_TOKEN_FAILURE = 'Please check your restore token, contact support if necessary.';
export const MESSAGE_COPYRIGHT = '© {date} salesforce.com,inc. All rights reserved. |';
export const MESSAGE_PRIVACY = 'Privacy Policy';

export const LABEL_RESTORE_TOKEN = 'Restore Token';
export const LABEL_NEXT = 'Next';
export const LABEL_KEY_ID = 'Key Id';
export const LABEL_KEY_ID_LONG = 'SFMC Encryption Key ID';
export const LABEL_AES_KEY = 'Wrapped AES Wrapping Key';
export const LABEL_RSA_KEY = 'Wrapped RSA Key Value';
export const LABEL_CANCEL = 'Cancel';
export const LABEL_RESTORE = 'Restore';
